import React, { useState, useEffect, useRef } from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import {
  HomefieldIconPlExplorer,
  HomefieldIconUserCircleOutlinedNew,
} from '@dsg-tech/homefield-react-icons';
import { AuthState, getAuthState } from 'utility/auth-utils';
import useLogger from 'hooks/useLogger';
import './MyAccount.scss';

interface MyAccountNewProps {
  isMyAccountDrawer: boolean;
  setShowDrawer: () => void;
  storeIdentifierName: string;
}

const MyAccount = ({
  isMyAccountDrawer,
  setShowDrawer,
  storeIdentifierName,
}: MyAccountNewProps) => {
  const [accountMainText, setAccountMainText] = useState('My Account');
  const [accountLinkText, setAccountLinkText] = useState('Sign In to Earn Points');
  const [auth, setAuth] = useState<any>({ name: undefined, isLoggedIn: false });
  const timeoutRef = useRef(null);
  const { error } = useLogger();

  useEffect(() => {
    if (auth.isLoggedIn) {
      setAccountMainText(auth.name ? `Hi, ${auth.name.replace(/%20/g, ' ')}` : 'Welcome');
      setAccountLinkText('My Account');
    }
  }, [auth]);

  useEffect(() => {
    getAuthState().then((authState: AuthState) => {
      setAuth(authState as any);
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const authClickHandler = () => {
    if (isMyAccountDrawer) {
      setShowDrawer();
      return;
    }
    if (auth.isLoggedIn) {
      window.location.href = '/MyAccount/AccountSummary';
      return;
    }
    window.authFunctions.login('/MyAccount/AccountSummary').catch((e: Error) => {
      error('MyAccount', { ErrorMessage: 'Could not login user', Error: e });
    });
  };

  return (
    <button
      className="header-my-account-new hmf-display-flex hmf-align-items-center hmf-px-md-xxs hmf-py-md-xxs"
      tabIndex={0}
      type="button"
      onClick={authClickHandler}
      onKeyDown={(e) => handleADA(e, 'button', authClickHandler)}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      data-em="Header_MyAccount_SignIn"
      aria-label={`My Account: ${accountMainText}`}>
      <div className="hmf-display-flex hmf-flex-column hmf-align-items-center">
        <HomefieldIconUserCircleOutlinedNew
          width={24}
          height={24}
          className={`user-icon ${
            storeIdentifierName === 'pl' ? 'hmf-display-block hmf-display-md-none' : ''
          }`}
        />
        {storeIdentifierName === 'pl' && (
          <HomefieldIconPlExplorer
            width="24px"
            height="24px"
            className="hmf-display-none hmf-display-md-block pl-explorer-icon"
          />
        )}
      </div>
      <div className="hmf-pl-xxs hmf-pr-xxxs hmf-display-none hmf-display-md-block hmf-text-align-left">
        <div className="hmf-body-bold-l">{decodeURIComponent(accountMainText)}</div>
        <div className="hmf-body-s">{accountLinkText}</div>
      </div>
    </button>
  );
};

export default MyAccount;
